import { useEffect, useState } from 'react';
import { useSessionStorage } from 'usehooks-ts';

import { UserSchema } from '@/features/users';
import { isNullish } from '@/types';

export type UsePreferencesProps = {
  readonly user?: UserSchema;
};

export function usePreferences({ user }: UsePreferencesProps) {
  const [open, setOpen] = useState(false);
  const [inSession, setInSession] = useSessionStorage('company-preferences', false);

  useEffect(() => {
    if (inSession) return;
    if (!user) return;

    const keys = [
      'activity_interests',
      'technology_interests',
      'other_technology',
      'countries_interests',
      'location_interests',
      'bess_size',
      'development_status_interests',
      'capacity_interests',
      'solar_size',
      'solar_development_status'
    ] as const;

    if (user.company && keys.every((key) => isNullish(user.company[key]))) {
      setOpen(true);
      setInSession(true);
    }
  }, [user, inSession, setInSession]);

  return {
    open,
    setOpen,
  };
}
